/**
 * Downloads a Blob as a file by programmatically clicking an anchor element
 * with the `download` attribute.
 *
 * We intentionally avoid pdfmake's built-in `.download()` (which uses
 * FileSaver.js) because its Safari / iOS fallback navigates to the blob URL
 * instead of downloading, causing the PDF to open inline in the browser's
 * PDF viewer. Some users perceive that as a print dialog.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  a.style.display = "none";

  document.body.appendChild(a);
  a.click();
  a.remove();

  // Revoke after the click has had a chance to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
